import { render, staticRenderFns } from "./TrustMarquee.vue?vue&type=template&id=66fe3020&"
import script from "./TrustMarquee.vue?vue&type=script&lang=js&"
export * from "./TrustMarquee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports